import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild} from '@angular/core';
import {VisualizarImagemOriginalService} from './visualizar-imagem-original.service';
import {ActivatedRoute} from '@angular/router';
import {VisualizarImagemOriginalRespostaModel} from './visualizar-imagem-original-resposta.model';

@Component({
  selector: 'app-visualizar-imagem-original',
  templateUrl: './visualizar-imagem-original.component.html',
  styleUrls: ['./visualizar-imagem-original.component.scss', '../../../styles-tab.scss']

})

export class VisualizarImagemOriginalComponent implements OnInit {
  @ViewChild('imagem', {static: true}) imagem: ElementRef;
  rot = 0;
  imagemOriginal = new VisualizarImagemOriginalRespostaModel();

  constructor(private renderer2: Renderer2,
              private visualizarImagemOriginalService: VisualizarImagemOriginalService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.rot = 0;
    this.visualizarImagemOriginalService.fotoOriginalChanged.subscribe((foto) => {
      this.imagemOriginal = foto;
    });

    const imagemId = this.route.snapshot.queryParams['LaudoVistoria'];
    const laudoId = this.route.snapshot.queryParams['key'];
    this.visualizarImagemOriginalService.obterLaudo(imagemId, laudoId);
  }

  rotateImage() {
    if (this.imagem.nativeElement.clientWidth > this.imagem.nativeElement.clientHeight) {
      if (this.rot === -90) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + ((this.imagem.nativeElement.clientWidth / 2) - (this.imagem.nativeElement.clientHeight / 2)) + 'px, 0px)');
        document.getElementById('divImagem').style.height = document.getElementById('imagem').clientWidth.toString() + 'px';
      } else if (this.rot === -270) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + ((this.imagem.nativeElement.clientWidth / 2) - (this.imagem.nativeElement.clientHeight / 2)) + 'px, 0px)');
        document.getElementById('divImagem').style.height = document.getElementById('imagem').clientWidth.toString() + 'px';
      } else if (this.rot === 90) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + ((this.imagem.nativeElement.clientWidth / 2) - (this.imagem.nativeElement.clientHeight / 2)) + 'px, 0px)');
        document.getElementById('divImagem').style.height = document.getElementById('imagem').clientWidth.toString() + 'px';
      } else if (this.rot === 270) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + ((this.imagem.nativeElement.clientWidth / 2) - (this.imagem.nativeElement.clientHeight / 2)) + 'px, 0px)');
        document.getElementById('divImagem').style.height = document.getElementById('imagem').clientWidth.toString() + 'px';
      } else {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(0px, 0px)');
        document.getElementById('divImagem').style.height = document.getElementById('imagem').clientHeight.toString() + 'px';
      }
    } else {

      if (this.rot === -90) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + ((this.imagem.nativeElement.clientHeight / 2) - (this.imagem.nativeElement.clientWidth / 2)) + 'px, 0px)');
      } else if (this.rot === -270) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + ((this.imagem.nativeElement.clientHeight / 2) - (this.imagem.nativeElement.clientWidth / 2)) + 'px, 0px)');
      } else if (this.rot === 90) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + ((this.imagem.nativeElement.clientHeight / 2) - (this.imagem.nativeElement.clientWidth / 2)) + 'px, 0px)');

      } else if (this.rot === 270) {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + ((this.imagem.nativeElement.clientHeight / 2) - (this.imagem.nativeElement.clientWidth / 2)) + 'px, 0px)');
      } else {
        this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(0px, 0px)');
      }
    }
  }

  rotateLeft() {

    if (this.rot === -270) {
      this.rot = 0;
    } else {
      this.rot -= 90;
    }
    this.rotateImage();
  }

  rotateRight() {

    if (this.rot === 270) {
      this.rot = 0;
    } else {
      this.rot += 90;
    }
    this.rotateImage();
  }

  @HostListener('window:resize')
  onResize() {
    if (this.rot === -90) {
      this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + (this.imagem.nativeElement.clientWidth / 4) + 'px, 0px)');
    } else if (this.rot === -270) {
      this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + (this.imagem.nativeElement.clientWidth / 4) + 'px, 0px)');
    } else if (this.rot === 90) {
      this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(+' + (this.imagem.nativeElement.clientWidth / 4) + 'px, 0px)');

    } else if (this.rot === 270) {
      this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(-' + (this.imagem.nativeElement.clientWidth / 4) + 'px, 0px)');
    } else {
      this.renderer2.setStyle(this.imagem.nativeElement, 'transform', 'rotate(' + this.rot.toString() + 'deg) translate(0px, 0px)');
    }
  }
}
